import {
	createRouter,
	createWebHashHistory
} from 'vue-router'


const routes = [{
		path: '/',
		redirect: '/home',
	}, {
		path: '/home',
		name: 'home',
		component: () => import('@/views/Home/Home.vue')
	},
]

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes
})

export default router